export type Shift = 'shift1' | 'shift2' | 'shift3';

export enum PortCollectionFeature {
  AppointmentScraping = 'appointment_scraping',
  LegacyTerminalScreenshots = 'legacy_terminal_screenshots',
  StopTheClock = 'stop_the_clock',
  TrackAndTrace = 'track_and_trace',
  VesselSchedule = 'vessel_schedule',
  SmartPerDiem = 'smart_per_diem',
}

export interface PortCollection {
  code: string;
  erlForecastDays: number;
  features: PortCollectionFeature[];
  geographicRegion: string | null;
  initials: string;
  name: string;
  perDiemArchiveMinDate: string | null;
  route: string;
  shifts: Shift[];
  shortName: string;
  smartPerDiemMinDate: string | null;
  terminalScreenshotsMinDate: string | null;
  timeZone: string;
}
